import React from 'react';

const Header = () => {
	return (
		<header className="header">
			<div className="header-nav">
				<h1 className="header-nav__logo">A</h1>
			</div>
			<div className="header-tagline">
				<h1 className="heading-primary">
					<span className="heading-primary__span heading-primary__span--1">
						Amber Cyr
					</span>
					<span className="heading-primary__span heading-primary__span--2">
						Web | Mobile
					</span>
				</h1>
			</div>
		</header>
	);
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js